import { render, staticRenderFns } from "./data-files-import-type-categorization.vue?vue&type=template&id=6a8883e8"
import script from "./data-files-import-type-categorization.vue?vue&type=script&lang=js"
export * from "./data-files-import-type-categorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports